import React, { useState,useEffect } from "react"
import { api } from "../../app/Api/ApiSlice"
import { useParams } from "react-router-dom"
import { toast } from "react-toastify"
import Loader from "../../components/Loader"

const StoreBranches = ()=>{
	const [branches,setBranches] = useState([])
	const [isLoading,setIsLoading] = useState(false)

	const {name} = useParams()

	useEffect(()=>{
		const getBranches = async()=>{
			try {
				setIsLoading(true)
				const response = await api.get(`/stores/${name}/branches`)
				// console.log(response)
				if(response){
					setIsLoading(false)
					setBranches(response.data.branches)
				}
				else{
					setIsLoading(false)
				}
			} catch (error) {
				setIsLoading(false)
				toast.error(error.response.data.message)
			}
		}

		getBranches()
	},[])

	// console.log("branches:",branches)
	return (
		<div className="store-branches-wrapper">
			 <div className="shelves-header">
                <h2>{name}  Branches</h2>
            </div>
			<div className="store-branches-list">
				{isLoading && <Loader />}
				{
					branches.length >0 && branches.map((branch)=>(
						<div className="branch-item">
							<h2>{branch.name}</h2>
						</div>
					))
				}
			</div>
			{!isLoading && branches.length === 0 && 
			<p className="not-found-msg">No Branches found</p>
				}
		
		</div>
		)
}

export default StoreBranches;